import "./OurServices.module.css";
import Header from "@/reusable_sections/Header";
import PricingTiers from "./sections/PricingTiers";
import ALaCarteServices from "./sections/ALaCarteServices";
import Footer from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <Header />
      <PricingTiers />
      <ALaCarteServices />
      <Footer />
    </div>;
}